import React from "react";
import PropTypes from 'prop-types';

const FormEmailConf = ({ settings }) => {
    return (
        <div className="row">
            <div className="col-lg-4 col-sm-4 col-12 mb-3">
                <label className="form-label">Servidor</label>
                <input type="text" className="form-control" value={settings?.server} disabled />
            </div>
            <div className="col-lg-4 col-sm-4 col-12 mb-3">
                <label className="form-label">Puerto</label>
                <input type="text" className="form-control" value={settings?.port} disabled />
            </div>
            <div className="col-lg-4 col-sm-4 col-12 mb-3">
                <label className="form-label" >Uso de TLS</label>
                <input type="checkbox" className="form-check" checked disabled style={{ width: 30, height: 30 }} />
            </div>
            <div className="col-lg-6 col-sm-6 col-12 mb-3">
                <label className="form-label">Usuario</label>
                <input type="text" className="form-control" value={settings?.user} disabled />
            </div>
            <div className="col-lg-6 col-sm-6 col-12 mb-3">
                <label className="form-label">Contraseña</label>
                <input type="password" className="form-control" value={settings?.hash} maxLength={10} disabled />
            </div>
        </div>
    );
};

FormEmailConf.propTypes = {
    settings: PropTypes.object.isRequired
};

export default FormEmailConf;
